import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.network.dns.zone.create;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_ZONE_CREATE',
	method: 'POST',
	url: '/network/dns/zone/create.json',
});

export { actions, reducer, sagas, selectors };
